import { createFileRoute } from "@tanstack/react-router";
import {
  bounceToAccountPath,
  haltForExternalNavigation,
} from "../lib/auth/app-origins";
import {
  normalizeSetupSearchCode,
  parseSetupTab,
  type UserSetupSearch,
} from "../lib/auth/user-setup-search";

/** User setup now lives on account-web — bounce old /user-setup bookmarks. */
export const Route = createFileRoute("/user-setup")({
  beforeLoad: () => {
    if (typeof window !== "undefined") {
      bounceToAccountPath("/user-setup", window.location.search);
      haltForExternalNavigation();
    }
  },
  validateSearch: (search: Record<string, unknown>): UserSetupSearch => ({
    tab: parseSetupTab(search),
    step: search.step === "phone" ? "phone" : undefined,
    email: (search.email as string) || undefined,
    code: normalizeSetupSearchCode(search.code),
  }),
  component: () => null,
});
